<template>
  <div class="wrapper-option search-wrapper">
    <div style="display: flex;">
      <div class="search-area">
        <el-form ref="form" size="mini" :inline="true" label-position="center">
          <el-form-item
            :label="item.label"
            v-for="(item, index) in labelList.slice(0, searchLen)"
            :key="`${item.label}${index}`"
            class="form"
          >
            <el-input
              v-if="item.type == 'text'"
              clearable
              :placeholder="item.placeholder"
              v-model="formData[item.key]"
              :style="formStyle"
            ></el-input>

            <el-select
              v-else-if="item.type == 'select'"
              clearable
              :multiple="item.multiple"
              :collapse-tags="item.collapseTags"
              :placeholder="item.placeholder"
              v-model="formData[item.key]"
              :style="formStyle"
              filterable
              @change="(data) => changeSelect(item.key, data)"
            >
              <el-option
                :value="option.value"
                v-for="(option, index) in item.option"
                :key="`${option.label}${index}`"
                :label="option.label"
              >
              </el-option>
            </el-select>
            <el-select
              v-else-if="item.type == 'select-remote'"
              clearable
              filterable
              remote
              :remote-method="item.method"
              v-model="formData[item.key]"
              :placeholder="item.placeholder"
              :style="formStyle"
            >
              <el-option
                :value="option.value"
                v-for="(option, index) in item.option"
                :key="`${option.label}${index}`"
                :label="option.label"
              >
              </el-option>
            </el-select>
            <el-date-picker
              v-else-if="item.type == 'date'"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              :pickerOptions="item.pickerOptions"
              unlink-panels
              v-model="formData[item.key]"
              :type="item.datetype"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 240px"
            >
            </el-date-picker>
            <el-date-picker
              v-else-if="item.type == 'month'"
              value-format="yyyy-MM"
              v-model="formData[item.key]"
              type="month"
              placeholder="选择月"
              :picker-options="item.pickerOptions"
            >
            </el-date-picker>
            <el-date-picker
              v-else-if="item.type == 'year'"
              value-format="yyyy"
              v-model="formData[item.key]"
              type="year"
              placeholder="选择年"
            >
            </el-date-picker>
            <el-popover
              v-else-if="item.type == 'text-tree'"
              popper-class="searchPlateNumber-popper"
              v-model="searchPlateNumberVisible"
              :visible-arrow="false"
              placement="bottom"
              width="240px"
              style="padding: 0"
              trigger="click"
              @show="currentKey = item.key"
            >
              <div style="height: 280px">
                <el-scrollbar style="height: 100%">
                  <el-tree
                    :data="treeData"
                    ref="orgTree"
                    show-checkbox
                    node-key="id"
                    default-expand-all
                    :props="props"
                    :expand-on-click-node="false"
                    @check="changeCheckTree"
                  >
                    <div class="custom-tree-node" slot-scope="{ data }">
                      <svg class="sideIcon" aria-hidden="true">
                        <use
                          :xlink:href="
                            data.childrens.length > 0
                              ? '#iconjiankong-yijiwenjianjia'
                              : data.model.extend
                              ? '#iconjiankong-qichelvse'
                              : '#iconjiankong-erjiwenjianjia'
                          "
                        ></use>
                      </svg>
                      {{ data.model.extend ? data.model.extend.plateNumber : data.model.orgName }}
                    </div>
                  </el-tree>
                </el-scrollbar>
              </div>
              <el-input
                slot="reference"
                clearable
                readonly
                v-model="formData[`${item.key}Str`]"
                :style="formStyle"
              ></el-input>
            </el-popover>
            <div v-else>
              <el-input v-model="formData[item.key][0]" placeholder="" clearable style="width: 90px"></el-input>
              -
              <el-input v-model="formData[item.key][1]" placeholder="" clearable style="width: 90px"></el-input>
            </div>
          </el-form-item>
          <div style="margin-top: 10px" class="moreWrapper" v-show="searchMore">
            <el-form-item
              v-show="searchMore"
              :label="item.label"
              v-for="(item, index) in labelList.slice(searchLen)"
              :key="`${item.label}${index}`"
            >
              <el-input
                v-if="item.type == 'text'"
                clearable
                :placeholder="item.placeholder"
                v-model="formData[item.key]"
                :style="formStyle"
              ></el-input>
              <el-select
                v-else-if="item.type == 'select'"
                clearable
                :multiple="item.multiple"
                :collapse-tags="item.collapseTags"
                v-model="formData[item.key]"
                :placeholder="item.placeholder"
                :style="formStyle"
                filterable
              >
                <el-option
                  :value="option.value"
                  v-for="(option, index) in item.option"
                  :key="`${option.label}${index}`"
                  :label="option.label"
                >
                </el-option>
              </el-select>
              <el-date-picker
                v-else-if="item.type == 'date'"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                :pickerOptions="item.pickerOptions"
                unlink-panels
                v-model="formData[item.key]"
                :type="item.datetype"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 240px"
              >
              </el-date-picker>
              <el-date-picker
                v-else-if="item.type == 'month'"
                value-format="yyyy-MM"
                v-model="formData[item.key]"
                type="month"
                placeholder="选择月"
                :picker-options="item.pickerOptions"
              >
              </el-date-picker>
              <el-date-picker
                v-else-if="item.type == 'year'"
                value-format="yyyy"
                v-model="formData[item.key]"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker>
              <div v-else>
                <el-input v-model="formData[item.key][0]" placeholder="" clearable style="width: 90px"></el-input>
                -
                <el-input v-model="formData[item.key][1]" placeholder="" clearable style="width: 90px"></el-input>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="more-area" v-show="initData.length > searchLen">
        <span style="cursor: pointer" @click="searchMore = !searchMore"
          ><i style="margin-right: 4px" :class="[searchMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i
          >{{ searchMore ? '收起筛选' : '高级筛选' }}</span
        >
      </div>
    </div>
    <div class="btn-area">
      <el-button style="height: 30px" type="primary" size="small" @click="search">查询</el-button>
      <el-button style="margin-left: 10px; height: 30px" size="small" @click="resetSearch(2)">重置</el-button>
      <slot name="button"></slot>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      labelList: [],
      searchMore: false,
      formData: {},
      labelLgh: 0,
      treeData: [],
      props: {
        children: 'childrens',
      },
      searchPlateNumberVisible: false,
      idList: { carIds: [], orgIds: [] },
      orgName: '',
      currentKey: null,
    }
  },
  props: {
    initData: {
      type: Array,
      default: () => [],
    },
    labelWidth: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(['searchLen']),
    formStyle() {
      return {
        width: `${this.labelWidth || 170}px`,
      }
    },
  },
  watch: {
    initData(val) {
      this.initSearch()
    },
  },
  mounted() {
    this.initSearch()
    this.getAsOrgTree()
  },
  methods: {
    changeCheckTree(a, { checkedNodes }) {
      this.idList = { carIds: [], orgIds: [] }
      this.distinguishId(checkedNodes)
    },
    changeSelect(key, data) {
      this.$emit('changeSelect', {
        key,
        data,
      })
    },
    distinguishId(checkedNodes) {
      checkedNodes.map((item) => {
        if (item.model.extend) {
          this.idList.carIds.push(item.id)
        } else {
          this.idList.orgIds.push(item.id)
        }
      })
      this.formData[this.currentKey] = this.idList.carIds
      this.formData[`${this.currentKey}OrgIds`] = this.idList.orgIds
      if (checkedNodes.length > 0) {
        // this.formData[`${this.currentKey}Str`] = this.treeData[0].model.orgName
        this.$set(this.formData, `${this.currentKey}Str`, this.treeData[0].model.orgName)
      } else {
        this.formData[`${this.currentKey}Str`] = ''
      }
    },
    async getAsOrgTree() {
      const data = await this.$api.getAsOrgTree()
      if (data.success) {
        let rootTree = data.datas.content
        this.treeData = rootTree.childrens || []
      }
      this.orgName = this.treeData[0].model.orgName
    },
    initSearch() {
      this.labelList = this.initData.map((v) => {
        if (this.formData[v.key] == '' || this.formData[v.key] == null) {
          this.$set(this.formData, v.key, v.value || '')
        }
        return v
      })
    },
    resetSearch() {
      this.initData.forEach((item) => {
        this.$set(this.formData, item.key, item.value || '')
      })
      this.search()
    },
    search() {
      this.$emit('search')
      this.$store.commit('updateHistorySearchData', {
        historyData: this.formData,
        path: this.$route.path,
      })
    },
    setFormData(data) {
      for(let i in data) {
        this.$set(this.formData, i, data[i] || '')
      }
    },
    getFormData() {
      let formData = {}
      this.labelList.forEach((item) => {
        if (item.type == 'date') {
          if (!this.formData[item.key]) {
            return false
          }
          formData[item.key[0]] = this.formData[item.key][0]
          formData[item.key[1]] = this.formData[item.key][1]
        } else if (item.type == 'select') {
          let defaultVal = item.default == 0 ? item.default : null
          formData[item.key] =
            this.formData[item.key] === 0
              ? this.formData[item.key]
              : this.formData[item.key] === false
              ? this.formData[item.key]
              : this.formData[item.key] || defaultVal
        } else if (item.type == 'text-tree') {
          // if(!this.formData[item.key]){
          //     return false
          // }
          formData[item.key] = this.formData[this.currentKey] || []
        } else {
          formData[item.key] =
            this.formData[item.key] || parseInt(this.formData[item.key]) === 0 ? this.formData[item.key] : null
        }
      })
      return formData
    },
  },
}
</script>
<style lang="scss">
.search-wrapper {
  display: flex;
  // flex-direction: row;
  justify-content: space-between;
  width: 100%;
  .el-popover {
    padding: 0 !important;
  }
  .btn-area {
    // width: 200px;
    // width: 130px;
    display: flex;
    margin-left: 10px;
    align-items: center;
  }
  .more-area {
    width: 105px;
    text-align: center;
    span {
      color: #2cac85;
      font-size: 13px;
      line-height: 30px;
    }
  }
  .search-area {
    flex: 1;
    .el-form-item--mini.el-form-item {
      margin-bottom: 0px;
    }
  }
  .el-range-editor--mini.el-input__inner {
    height: 30px;
  }
  .el-form--inline .el-form-item__label {
    height: 30px;
    padding: 0 12px;
    font-size: 12px;
    line-height: 30px !important;
    text-align: center;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
  .el-input__inner {
    height: 30px !important;
    line-height: 30px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .moreWrapper {
    .el-form-item--mini.el-form-item {
      margin-bottom: 10px;
    }
  }
}
</style>
